const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/report-advices/api-factory');
const serviceFactory = require('../resources/report-advices/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/reports/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}advices.getAdvicesData[{keys:fromDate}][{keys:toDate}][{keys:portfolioId}][{keys:outputType}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
       service.getAdviceItems(req.params.fromDate, req.params.toDate, req.params.portfolioId, req.params.outputType, req.params.metaData)
        .then(response => res.value(response))
        .catch(res.error)
      )))
    .match(`${p}advices.getSelectedAdviceItem[{keys:fromDate}][{keys:toDate}][{keys:portfolioId}][{keys:outputType}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
       service.getAdviceItemList(req.params.fromDate, req.params.toDate, req.params.portfolioId, req.params.outputType, req.params.metaData)
        .then(response => res.value(response))
        .catch(res.error)
      )))
      
      // WMCE-4443, BELOW PATHS CREATED TO MATCH PATHS FOR BP IDS AS BP ID WILL BE INTEGER, BP CONSOLIDATION
      .match(`${p}advices.getAdvicesData[{keys:fromDate}][{keys:toDate}][{integers:portfolioId}][{keys:outputType}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
         service.getAdviceItems(req.params.fromDate, req.params.toDate, req.params.portfolioId, req.params.outputType, req.params.metaData)
          .then(response => res.value(response))
          .catch(res.error)
        )))
      .match(`${p}advices.getSelectedAdviceItem[{keys:fromDate}][{keys:toDate}][{integers:portfolioId}][{keys:outputType}]`, requests => Promise.all(
        requests.map(({ req, res }) => 
         service.getAdviceItemList(req.params.fromDate, req.params.toDate, req.params.portfolioId, req.params.outputType, req.params.metaData)
          .then(response => res.value(response))
          .catch(res.error)
        )))

    .match(`${p}advices.getPdf[{keys:accountId}][{keys:docId}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
     {
      if (req.params.accountId) req.params.accountId = req.params.accountId.slice(4);
      if (req.params.docId) req.params.docId = req.params.docId.replace('<<<dot>>>', '.');

      return service.getPdfStatement(req.params)
        .then(response => res.value(response.data))
        .catch(res.error)
    }
    )))
}

module.exports = addRoutes;
